import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Dialog,
  Paper,
  AppBar,
  IconButton,
  Typography,
  Slide,
  Fade,
  Chip} from '@material-ui/core';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import { format } from 'date-fns';
import LinearProgressBlockScreen from '../../share/LinearProgressBlockScreen';
import MensalidadeService from '../../../services/MensalidadeService';
import MUIDataTable from 'mui-datatables';
import EditableNumber from '../../share/EditableNumber';
import VariantSnackbar from '../../share/VariantSnackbar';

const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  toolbar: {
    display: 'flex',
    backgroundColor: '#5c6bc0',
    justifyContent: 'flex-start',
    alignItems: 'center',
    cursor: 'pointer',
    padding: theme.spacing.unit * 2,
  },
  flex: {
    display: 'inline'
  },
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    margin: theme.spacing.unit * 2,
  },
  tableCell: {
    maxWidth: 400,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 40,
  },
  invisible: {
    display: 'none',
  },
  chip: {
    marginLeft: theme.spacing.unit * 4,
    marginBottom: theme.spacing.unit,
  },
});

function Transition (props) {
  return <Slide direction='left' {...props} />;
}

class FullScreenMensalidade extends React.Component {
  mensalidadeService = new MensalidadeService();

  state = {
    valores: [],
    valorSelecionado: {},
    fetching: true,
    snackOpen: false,
    snackMessage: 'Valor alterado com sucesso.',
    snackSucesso: true
  }
  componentDidMount = async () => {
    this.setState({fetching: true});
    await this.consultarValoresMensalidade();
    this.setState({fetching: false});
  }
  consultarValoresMensalidade = async () => {
    this.setState({valores: []});
    let valores = await this.mensalidadeService.consultarValoresMensalidade(this.props.mensalidade.numSeqMensalidade,
      this.props.apenasValoresZerados);
    this.setState({valores: valores});
  }
  handleClickSave = async (valor) => {
    this.state.valorSelecionado.valMensalidade = Number(valor.replace('.', '').replace('.', '').replace(',', '.'));
    let result = await this.mensalidadeService.salvarValorMensalidade(this.state.valorSelecionado);
    this.onOperacaoFinalizada(result);
  };
  onOperacaoFinalizada = async (result) => {
    if (result === undefined || result.data === undefined) {
      this.setState({
        snackOpen: true,
        snackMessage: 'Não foi possível realizar a operação. Favor tentar novamente.',
        snackSucesso: false,
        fetching: false});
    } else {
      if (result.data.codigoRetorno === 1) {
        this.setState({
          snackOpen: true,
          snackMessage: result.data.msgRetornoResumida,
          fetching: false,
          snackSucesso: true});
      } else {
        this.setState({
          snackOpen: true,
          snackMessage: result.data.msgRetornoResumida,
          fetching: false,
          snackSucesso: false});
      }
    }
    await this.consultarValoresMensalidade();
  }
  handleNumberFocus = async (rowMeta) => {
    const valor = {
      seqMensalidade: this.state.valores[rowMeta.rowIndex][0],
      seqValor: this.state.valores[rowMeta.rowIndex][1],
      codTipoMensalidade: this.state.valores[rowMeta.rowIndex][2],
      desTipoMensalidade: this.state.valores[rowMeta.rowIndex][3],
      seqRemuneracao: this.state.valores[rowMeta.rowIndex][4],
      desRemuneracao: this.state.valores[rowMeta.rowIndex][5],
      seqIdade: this.state.valores[rowMeta.rowIndex][6],
      desIdade: this.state.valores[rowMeta.rowIndex][7],
      codUsuarioCadastro: this.state.valores[rowMeta.rowIndex][8],
      valMensalidade: this.state.valores[rowMeta.rowIndex][9],
      dtaCadastro: this.state.valores[rowMeta.rowIndex][10],
    };
    this.setState({valorSelecionado: valor});
  }
  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  }
  handleChangePage = async (currentPage) => {
    // this.setState({fetching: true});
    await setTimeout(() => {
      console.log(currentPage);
    }, 3000);
    // this.setState({fetching: false});
  }
  render () {
    const options = {
      onChangePage: (currentPage) => (this.handleChangePage(currentPage)),
      print: false,
      download: false,
      selectableRows: false,
      filterType: 'dropdown',
      rowsPerPageOptions: [5, 10, 15],
      rowsPerPage: 10,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        toolbar: {
          search: 'Procurar',
          viewColumns: 'Ver Colunas',
          filterTable: 'Filtrar',
        },
        filter: {
          all: 'Todos',
          title: 'FILTROS',
          reset: 'RESET',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
      }
    };
    const columns = [
      {
        name: 'codigo',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'codValor',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'codTipoMensalidade',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Tipo de Mensalidade',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'seqRemuneracao',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Faixa de Remuneração',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'seqIdade',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Faixa de Idade',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'usuario',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Valor Mensalidade',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value, rowMeta) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return ((value === 0 || this.props.modoEdicao)
              ? this.state.fetching ? null : <EditableNumber
                index={this.state.valores[rowMeta.rowIndex][1]}
                isMoney
                tamanho={7}
                value={value}
                handleSave={this.handleClickSave}
                handleFocus={() => this.handleNumberFocus(rowMeta)}
              />
              : <Typography>{nf.format(value)}</Typography>
            );
          },
        },
      },
      {
        name: 'dataCadastro',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
    ];

    const { classes, open, handleClose } = this.props;
    const { valores, fetching } = this.state;
    return (
      <div>
        <Dialog
          fullScreen
          open={open}
          onClose={handleClose}
          scroll='paper'
          TransitionComponent={Transition}
        >
          <AppBar className={classes.appBar}>
            <Paper square elevation={0} className={classes.toolbar} onClick={handleClose} color='inherit'>
              <IconButton color='inherit' onClick={handleClose} aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='title' color='inherit' className={classes.flex}>
                Sequencial - {this.props.mensalidade.numSeqMensalidade} - Valores de Mensalidade de {format(new Date(this.props.mensalidade.dtaInicio), 'MM/YYYY')}
                {format(new Date(this.props.mensalidade.dtaFim), 'YYYY') === '1969' ? '' : ' a ' + format(new Date(this.props.mensalidade.dtaFim), 'MM/YYYY')}
              </Typography>
              <Typography variant='title' color='inherit' className={classes.flex}>
                {valores && <Chip label={valores.length + ' registro(s)'} className={classes.chip} />}
              </Typography>
            </Paper>
          </AppBar>
          {fetching ? <LinearProgressBlockScreen />
            : <Fade timeout={1000} in>
              <Paper className={classes.body} elevation={1}>
                <MUIDataTable
                  data={valores}
                  columns={columns}
                  options={options}
                />
              </Paper>
            </Fade>}
        </Dialog>
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.snackSucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          handleClose={this.handleCloseSnackbar} />
      </div>
    );
  }
}

export default withStyles(styles)(FullScreenMensalidade);
